function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M6.577 20v-9.123h2.988l.447-3.555H6.577v-2.27c0-1.03.28-1.731 1.72-1.731l1.836-.001V.14A24.025 24.025 0 0 0 7.457 0C4.808 0 2.995 1.657 2.995 4.7v2.622H0v3.555h2.995V20h3.582z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 11,
    height: 20,
    viewBox: "0 0 11 20"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/facebook-white.a1062a44.svg";
export { SvgComponent as ReactComponent };